<style scoped lang="scss" type="text/scss">

</style>

<template>
    <el-dialog
            title="需要绑定手机号"
            :close-on-click-modal="false"
            :visible.sync="visibleSync"
            :closeOnPressEscape="false"
            :showClose="false"
            width="70%">
        <el-form :model="info" ref="form" :rules="rules" label-width="80px">
            <el-form-item label="原手机号" prop="oldMobile">
                <el-input v-model="info.oldMobile" disabled></el-input>
            </el-form-item>
            <el-form-item label="新手机号" prop="mobile">
                <el-input v-model="info.mobile"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="loadVerificationCode" :plain="waitSeconds === 0" :disabled="!canSend"
                           :loading="sendVerificationCodeRequesting"
                           :type="waitSeconds === 0 ? 'default' : 'primary'">
                    <span v-if="waitSeconds === 0">获取验证码</span>
                    <span v-else>已发送（ {{ waitSeconds }} s ）</span>
                </el-button>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
                <el-input v-model="info.code"></el-input>
            </el-form-item>

            <el-form-item style="margin-bottom: 0;">
                <el-button type="primary" plain @click="confirm()" :loading="bindingRequesting">确认</el-button>
<!--                <el-button @click="cancel()">取消</el-button>-->
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    import {isMobile} from '../../../../../utils/regex';
    import _ from 'lodash';

    export default {
        name: '',
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            visible (visible) {
                this.visibleSync = visible;
            },
            visibleSync (visibleSync) {
                this.$emit('update:visible', visibleSync);
            },
            selfInfo: {
                immediate: true,
                handler (selfInfo) {
                    let mobile = _.get(selfInfo, 'mobile', null);
                    if (mobile === null) mobile = '未绑定手机';
                    this.info.oldMobile = mobile;
                }
            }
        },
        data () {
            const checkMobile = async (rule, value, callback) => {
                if (!isMobile(value)) {
                    callback(new Error('请输入正确的 11 位手机号'));
                }
                const exists = await this.checkExists(value);
                if (exists) {
                    callback(new Error('该手机号已被占用'));
                } else {
                    callback();
                }
            };
            const checkMobileRedundant = (rule, value, callback) => {
                if (value === this.info.oldMobile) {
                    callback(new Error('新手机号不能与原手机号相同'));
                }
                callback();
            };

            return {
                sendVerificationCodeRequesting: false,
                bindingRequesting: false,
                visibleSync: null,
                waitSeconds: 0,
                canSend: true,
                info: {
                    mobile: null,
                    code: null
                },
                rules: {
                    oldMobile: [
                        {required: true, message: '手机号不能为空'}
                    ],
                    mobile: [
                        {required: true, message: '手机号不能为空', trigger: 'blur'},
                        {validator: checkMobileRedundant, trigger: 'blur'},
                        {validator: checkMobile, trigger: 'blur'}
                    ],
                    code: [
                        {required: true, message: '验证码不能为空', trigger: 'blur'},
                        {min: 6, max: 6, message: '请输入 6 位验证码', trigger: 'blur'}
                    ]
                }
            };
        },
        computed: {
            selfInfo () {
                return this.$store.state.user.selfInfo;
            }
        },
        methods: {
            checkExists (mobile) {
                return this.$store.dispatch('user/mobileExists', {
                    mobile
                }).then(response => {
                    return Promise.resolve(response.data);
                });
            },
            async loadVerificationCode () {
                if (this.waitSeconds > 0) return;
                const mobile = this.info.mobile;
                if (isMobile(mobile)) {
                    const exists = await this.checkExists(mobile);
                    if (exists) {
                        this.$tip('手机号被占用', 'error');
                    } else {
                        this.sendVerificationCodeRequesting = true;
                        this.$normalRequest('user/bindingMobileVerificationCode', {mobile}, null).then(_ => {
                            this.sendVerificationCodeRequesting = false;
                            this.canSend = false;
                            this.waitSeconds = 60;
                            const timer = setInterval(() => {
                                if (this.waitSeconds === 0) {
                                    clearInterval(timer);
                                    this.canSend = true;
                                } else {
                                    this.waitSeconds -= 1;
                                }
                            }, 1000);
                        }).catch(_ => {
                            this.sendVerificationCodeRequesting = false;
                            this.canSend = true;
                        });
                    }
                }
            },
            confirm () {
                this.$refs.form.validate((valid) => {
                    if (!valid) return false;
                    this.bindingRequesting = true;
                    this.$normalRequest('user/bindingMobile', {
                        mobile: this.info.mobile,
                        verification_code: this.info.code
                    }, '手机绑定成功').then(_ => {
                        this.bindingRequesting = false;
                        this.closeAndClear();
                        this.$store.dispatch('user/loadSelfInfo').then();
                    }).catch(_ => {
                        this.bindingRequesting = false;
                    });
                });
            },
            cancel () {
                this.closeAndClear();
            },
            closeAndClear () {
                this.info.mobile = null;
                this.info.code = null;
                this.close();
            },
            close () {
                this.$refs.form.clearValidate();
                this.visibleSync = false;
            }
        }
    };
</script>
